import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { cn } from "../utils/cn";

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "zh" ? "en" : "zh";
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className={cn(
        "flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-sm font-medium",
        "bg-slate-100 hover:bg-slate-200 text-slate-700 transition-colors"
      )}
    >
      <Globe className="w-4 h-4" />
      <span>{i18n.language === "zh" ? "EN" : "中文"}</span>
    </button>
  );
}
